import { useEffect, useState } from 'react';

const EVENTS = ['scroll'];
const MILISECONDS_INACTIVE = 120_000;

export function useInactiveUser(
  timeMs = MILISECONDS_INACTIVE,
  events = EVENTS
) {
  const [isUserInactive, setUserInactive] = useState(false);

  useEffect(() => {
    let timerId: NodeJS.Timeout;

    const checkActivity = () => {
      clearTimeout(timerId);
      setUserInactive(false);

      timerId = setTimeout(() => {
        setUserInactive(true);
      }, timeMs);
    };

    checkActivity();
    events.forEach((event) =>
      document.addEventListener(event, checkActivity, false)
    );

    return () => {
      clearTimeout(timerId);
      events.forEach((event) =>
        document.removeEventListener(event, checkActivity, false)
      );
    };
  }, [timeMs, events]);

  return { isUserInactive };
}
